export const iconFontAwesomeGamingDiamond = (
	<i className="fa-solid fa-diamond"></i>
);
